/**
 * Error Modal Service
 * Manages global error modal state for displaying API errors to users.
 */

// State
let isOpen = false;
let errorMessage = '';
let correlationId = '';
let onCloseCallback: (() => void) | undefined;

// Listeners
type Listener = (state: { isOpen: boolean; errorMessage: string; correlationId: string }) => void;
const listeners: Set<Listener> = new Set();

function notifyListeners() {
  listeners.forEach(listener => listener({ isOpen, errorMessage, correlationId }));
}

// Show the error modal
export function showErrorModal(message: string, corrId?: string, onClose?: () => void) {
  errorMessage = message;
  correlationId = corrId || '';
  onCloseCallback = onClose;
  isOpen = true;
  notifyListeners();
}

// Close the error modal
export function closeErrorModal() {
  isOpen = false;
  errorMessage = '';
  correlationId = '';

  // Execute callback if provided
  const callback = onCloseCallback;
  onCloseCallback = undefined;

  notifyListeners();

  // Call callback after notifying listeners
  if (callback) {
    callback();
  }
}

// Subscribe to state changes
export function subscribeToErrorModal(listener: Listener): () => void {
  listeners.add(listener);
  // Immediately notify with current state
  listener({ isOpen, errorMessage, correlationId });
  return () => listeners.delete(listener);
}

// Convenience export
export const errorModalService = {
  show: showErrorModal,
  close: closeErrorModal,
  subscribe: subscribeToErrorModal,
};
